export default __webpack_public_path__ + "static/N0240-ad90b99f78a39eae027a691ecf3d286f.png";